import { render, staticRenderFns } from "./Done_Adjustments_to_Building_Power.vue?vue&type=template&id=70101216"
import script from "./Done_Adjustments_to_Building_Power.vue?vue&type=script&lang=js"
export * from "./Done_Adjustments_to_Building_Power.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports